import { Box, Chip, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { flexCenter } from "../../../shared/lib/theme/styleConstants";
import palette from "./palette";
import { TransactionHistoryProps } from "../../../admin/src/app/interfaceTypes";

export const AuthLogoBox = styled(Box)({
  backgroundColor: palette.blackOne,
  width: "444px",
  borderRadius: "16px",
  ...flexCenter,
  flexDirection: "column",
  position: "relative",
});

export const ErrorBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "100%",
  transform: `translate(-50%, -50%)`,
  p: {
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
  },
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  fontSize: "30rem",
  fontWeight: "600",
  opacity: "0.1",

  [theme.breakpoints.down("lg")]: {
    fontSize: "25rem",
  },

  [theme.breakpoints.down("md")]: {
    fontSize: "18rem",
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "10rem",
  },
}));

export const PageNotFountText = styled(Typography)(({ theme }) => ({
  fontSize: "68px",
  textAlign: "center",

  [theme.breakpoints.down("md")]: {
    fontSize: "48px",
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "28px",
  },
}));

export const AppLoading = styled(Box)(() => ({
  height: "100vh",
  width: "100%",
  flexDirection: "column",
  ...flexCenter,
}));

export const CustomPhoneContainer2 = styled(Box)(() => ({
  ".react-tel-input .form-control": {
    height: "56px",
    paddingLeft: "55px !important",
    // "-webkit-appearance": "none",
    border: "1px solid rgba(145, 158, 171, 0.32) !important",

    "&:focus": {
      outline: "none",
    },
  },

  ".MuiFormControl-root.MuiFormControl-fullWidth": {
    marginTop: "8px",
  },

  ".country-list": {
    width: "240px !important",
  },

  ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
    // transform: " translate(10px, -6px) scale(0.75)",
    background: "none",
    padding: "0 6px",
    zIndex: "99",
    backgroundColor: palette.white,
  },

  ".display_none": {
    display: "none!important",
  },

  ".special-label": {
    display: "none!important",
  },

  ".transparent": {
    color: "transparent",
  },

  ".appearance": {
    "-webkit-appearance": "none",
  },
}));

export const CustomPhoneContainer = styled(Box)(() => ({
  ".react-tel-input .form-control": {
    height: "56px",
    paddingLeft: "55px !important",
    "-webkit-appearance": "none",

    "&:focus": {
      outline: "none",
    },
  },

  ".MuiFormControl-root.MuiFormControl-fullWidth": {
    marginTop: "8px",
  },

  ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
    transform: " translate(10px, -6px) scale(0.75)",
    background: "none",
    padding: "0 6px",
    zIndex: "99",
    backgroundColor: palette.white,
  },

  ".display_none": {
    display: "none!important",
  },

  ".special-label": {
    display: "none!important",
  },

  ".transparent": {
    color: "transparent",
  },

  ".appearance": {
    "-webkit-appearance": "none",
  },

  ".flag-dropdown": {
    display: "none!important",
  },
}));

export const PinInputWrapper = styled(Box)(({ theme }) => ({
  // react-pin-input sets width/height inline on every input, so the sizes below
  // need !important or the responsive rules are ignored and the six boxes wrap.
  "& .pincode-input-container": {
    display: "flex",
    justifyContent: "center",
    flexWrap: "nowrap",

    "& .pincode-input-text": {
      padding: "0 !important",
      background: "transparent",
      width: "50px !important",
      height: "50px !important",
      boxSizing: "border-box",
      flexShrink: 0,
      borderRadius: "8px",
      marginRight: "16px !important",

      "&:last-child": {
        marginRight: "0 !important",
      },

      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },

      [theme.breakpoints.down("md")]: {
        width: "40px !important",
        height: "40px !important",
        marginRight: "5px !important",
      },

      [theme.breakpoints.down("sm")]: {
        width: "38px !important",
        height: "38px !important",
        marginRight: "4px !important",
      },
    },
  },
}));

export const TransactionsHistoryChipStyle = styled(
  Chip
)<TransactionHistoryProps>(({ customcolor }) => ({
  borderRadius: "6px",
  border: `1px solid ${customcolor}`,
  fontSize: "12px",
  fontWeight: "700",
  backgroundColor: "transparent",
  color: customcolor,
}));
